import React, { useState } from 'react';
import { Input, Switch } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useSearchParams } from 'react-router-dom';
import { AvailablePhoneNumberCountryInterface, resetNumbers } from "src/store/callrecorder/availablePhoneNumbersSlice";
import { useAppDispatch } from "src/store/hooks";
import { queryParams } from "src/helpers/UrlHelpers";
import ListVertical from "src/componets/ListVertical";

interface FilterInterface {
  countries: AvailablePhoneNumberCountryInterface[];
}

const _Filter = ({ countries }: FilterInterface) => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState('');

  const countryCode = queryParams.get(searchParams, 'country_code') || null;
  const sms = searchParams.get('sms_enabled') === 'true';
  const mms = searchParams.get('mms_enabled') === 'true';
  const calls = searchParams.get('trunking_enabled') === 'true';
  const filteredCountries = countries.filter(c =>
    `${c.country_name} ${c.prefix}`.toLowerCase().includes(search.toLowerCase())
  );

  function onCountryClick(code: string) {
    searchParams.set('country_code', code);
    setSearchParams(searchParams, { replace: true });
  }

  function resetCountryAndNumbers() {
    searchParams.delete('country_code');
    searchParams.delete('phone_number_type');
    dispatch(resetNumbers());
  }

  function onCallsChange(value: boolean) {
    resetCountryAndNumbers();
    if (value) {
      searchParams.set('trunking_enabled', 'true');
    } else {
      searchParams.delete('trunking_enabled');
    }
    setSearchParams(searchParams, { replace: true });
  }

  function onInboundSmsChange(value: boolean) {
    resetCountryAndNumbers();
    if (value) {
      searchParams.set('sms_enabled', 'true');
    } else {
      searchParams.delete('sms_enabled');
    }
    setSearchParams(searchParams, { replace: true });
  }

  function onOutgoingMmsChange(value: boolean) {
    resetCountryAndNumbers();
    if (value) {
      searchParams.set('mms_enabled', 'true');
    } else {
      searchParams.delete('mms_enabled');
    }
    setSearchParams(searchParams, { replace: true });
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Switch size='small' checked={calls} onChange={onCallsChange} />
          <small>Calls</small>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Switch size='small' checked={sms} onChange={onInboundSmsChange} />
          <small>SMS</small>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Switch size='small' checked={mms} onChange={onOutgoingMmsChange} />
          <small>MMS</small>
        </div>
      </div>

      <div>
        <small className='v-content-label o-sm'>Country</small>
        <Input
          placeholder='Search country...'
          prefix={<SearchOutlined />}
          value={search}
          onChange={e => setSearch(e.target.value)}
          allowClear
        />
      </div>

      <ListVertical>
        {filteredCountries.map(c => (
          <ListVertical.Item
            key={c.country_code}
            active={countryCode === c.country_code}
          >
            <a onClick={() => onCountryClick(c.country_code)} style={{ cursor: 'pointer' }}>
              {c.country_name} ({c.prefix})
            </a>
          </ListVertical.Item>
        ))}
      </ListVertical>
    </div>
  );
}

export default _Filter;
